import script from "./BaseAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&setup=true&lang=js"

import "./BaseAvatar.vue?vue&type=style&index=0&id=bff379c2&lang=scss&scoped=true"

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bff379c2"]])

export default __exports__